module.exports = __webpack_public_path__ + "img/116038.168aacb4.png";